import React from "react";
import NavDropdown from "react-bootstrap/NavDropdown";
import { FaGlobe } from "react-icons/fa";
import { useLanguage } from "../context/LanguageContext";

const LABELS = {
  az: "Azərbaycan",
  ru: "Русский",
  en: "English",
};

function LanguageSwitcher() {
  const { lang, setLang, t } = useLanguage();
  const current = LABELS[lang] || LABELS.az;

  const title = (
    <>
      <span className="visually-hidden">
        {t("lang.aria")}
        {current}
      </span>
      <span className="lang-switcher-title d-inline-flex align-items-center gap-2">
        <FaGlobe className="lang-switcher-globe" aria-hidden />
        <span className="lang-switcher-caption">{t("lang.caption")}</span>
        <span className="lang-switcher-sep" aria-hidden>
          ·
        </span>
        <span className="lang-switcher-current">{current}</span>
      </span>
    </>
  );

  return (
    <NavDropdown
      title={title}
      id="lang-nav-dropdown"
      className="lang-switcher"
      align="end"
    >
      <NavDropdown.Header className="lang-switcher-header small text-white-50">
        {t("lang.caption")}
      </NavDropdown.Header>
      <NavDropdown.Item active={lang === "az"} onClick={() => setLang("az")}>
        Azərbaycan
      </NavDropdown.Item>
      <NavDropdown.Item active={lang === "ru"} onClick={() => setLang("ru")}>
        Русский
      </NavDropdown.Item>
      <NavDropdown.Item active={lang === "en"} onClick={() => setLang("en")}>
        English
      </NavDropdown.Item>
    </NavDropdown>
  );
}

export default LanguageSwitcher;
